import React from "react";
import { NavigationalButtons } from "./CreateCourseWizard";
import { Form, Formik } from "formik";
import ActionPlanTipList from "../ActionPlanTip/ActionPlanTipList";

const ActionPlanTipStep = ({ courseId, revId, nextOnClick, prevOnClick }) => {

    return (
        <div>
            <ActionPlanTipList crsId={courseId} revId={revId} />
            <Formik
                initialValues={{}}
                onSubmit={async () => {
                    nextOnClick();
                }}
            >
                <Form>
                    <NavigationalButtons
                        onNextProps={{ type: "submit", text: "Save and Continue" }}
                        onPrevHandler={prevOnClick}
                    />
                </Form>
            </Formik>
        </div>
    );
};

export default ActionPlanTipStep;
